import React from "react";
import '../../pages/prompt-library/prompt-library.css';
import LighteningBolt1 from '../elements-icons/LighteningBolt1';

const PromptBox = ({ prompt, task, index, setClipboard }) => {
  return (
    <li key={index}
        className='prompt-wrapper'>
      {/* Set Task Title */}
      {task?.title ?
        <h3
          className='title-sub-4 semi-bold'>
          {task.title}
        </h3> :
        ''
      }
      {/* Set Prompt */}
      <p className='paragraph-sub-4'>
      {prompt?.prompt ? prompt.prompt :
        !prompt?.prompt && task?.title ?
          'Coming Soon' : ''
      }
      </p>
      {/* Set Prompt Button */}
      {prompt?.prompt ?
        <div className='copy-btn'>
          <button
            className='btn-cta-sub bg-straight-gradient-purple text-lt'
            onClick={() =>
              (setClipboard(prompt))}>
            Copy Prompt
            <LighteningBolt1
              svgClass='icon-sm'
              pathClass='icon-wht' />
          </button>
        </div>
         : ''
      }
      {/* Set Prompt Documentation */}
      {prompt?.documentation ? <div className='prompt-documentation'>
        <h3 className='title-sub-4 semi-bold'>Tips for using this prompt</h3>
        <p className='paragraph-sub-4'>{prompt.documentation}</p>
      </div> :
        ''
      }
    </li>
  );
}

export default PromptBox;